<template>
  <div :class="$style.wrapper"></div>
</template>

<script>
export default {
  mounted() {
    this.$bus.$on("show-full-overlay", this.handleShow);
    this.$bus.$on("hide-full-overlay", this.handleHide);
  },
  methods: {
    handleShow() {
      TweenMax.to("." + this.$style.wrapper, 0.5, {
        opacity: 1,
        pointerEvents: "auto"
      });
    },
    handleHide() {
      TweenMax.to("." + this.$style.wrapper, 0.5, {
        opacity: 0,
        pointerEvents: "none"
      });
    }
  }
};
</script>

<style lang='scss' module>
@import "../assets/css/globals.scss";

.wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  background-color: rgba(0, 0, 0, 0.5);

  z-index: 750;

  opacity: 0;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/FullScreenOverlay.vue